module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"da":{"price-savings":{"savings":"Besparelse"}},"de":{"version":1,"price-savings":{"savings":"Ersparnis"}},"fr":{"price-savings":{"savings":"Économies"}},"nl":{"price-savings":{"savings":"Besparing"}}}')
  delete Component.options._Ctor
}
